import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatTableDataSource} from '@angular/material';
import {AgenceService} from '../../../agence/shared/services/agence.service';
import {Bureau} from '../../../core/shared/classes/bureau';
import {Agence} from '../../../core/shared/classes/agence';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-bureaux-select',
  templateUrl: './bureaux-select.component.html',
  styleUrls: ['./bureaux-select.component.css']
})
export class BureauxSelectComponent implements OnInit {
  @Input() _formControl: FormControl;

  @Output() selectBureau = new EventEmitter();

  public bureaux: Bureau[] = [];
  public currentAgence;

  constructor(private agenceService: AgenceService) { }

  ngOnInit() {
    this.currentAgence = new Agence(JSON.parse(localStorage.getItem('agence')));
    this.getBureaux();
  }

  getBureaux() {
    this.bureaux = [];
    this.agenceService.getBureaux(this.currentAgence.id)
        .subscribe(retour => {
          this.bureaux = retour.data;
        });
  }
  
}
